import React from 'react'
import { Navbar, Container, Nav, Image } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import { ACCESS_TOKEN } from '../../common/local-storage/Contants'

function NavBar() {

    const navigate = useNavigate()
    return (
        <Navbar className='font-link' bg="dark" variant="dark" sticky="top" expand="md">

            <Container>
                <Navbar.Brand>
                    <Image width={40} src='https://management.fahfon.info/images/icon/logo.png' />

                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav">

                </Navbar.Toggle>
                <Navbar.Collapse>
                    <Nav>
                        <Nav.Link as={Link} to="/">Account</Nav.Link>
                        <Nav.Link as={Link} to="/manage-package">Manage Package</Nav.Link>
                        <Nav.Link as={Link} to="/search-member">Member</Nav.Link>
                        <Nav.Link as={Link} to="/search-user-package">User Package</Nav.Link>

                    </Nav>
                </Navbar.Collapse>

                <Navbar.Collapse className="justify-content-end">
                    <Navbar.Text>
                        Signed in as: Admin <a href="#" onClick={() => {
                            onLogout()

                        }}>Logout</a>
                    </Navbar.Text>
                </Navbar.Collapse>


            </Container>

        </Navbar>
    )

    function onLogout() {

        localStorage.removeItem(ACCESS_TOKEN)

        navigate('/login')

    }
}

export default NavBar